import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useAppSelector } from 'hooks/useStore';
import { FaExclamation } from 'react-icons/fa';
import { MdPlayCircle } from 'react-icons/md';
import { RiMoreFill } from 'react-icons/ri';
import axios from 'config/axios';
import Loader from 'components/Loader';
import CourseVector from 'assets/vectors/CoursePlaceholder.svg';

import './index.css';

function Courses() {
    const [courses, setCourses] = useState(null);

    const navigate = useNavigate();
    const { organization } = useAppSelector(state => state.organization);

    useEffect(() => {
        axios.get(`courses/courses/${organization.urlSlug}/`)
            .then(res => {
                // console.log(res.data);
                setCourses(res.data.courses);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    if (courses === null) return <Loader />;

    return (
        <div className='layout'>
            <Helmet>
                <title>
                    Lectures - {organization.name}
                </title>
            </Helmet>
            <div className='courses'>
                {courses.map(course => (
                    <button
                        className='courses__course'
                        onClick={() => navigate(`/lectures/${course.urlSlug}`)}
                        key={course.id}
                    >
                        <img className='courses__courseVector' src={CourseVector} />
                        <div className='courses__info'>
                            <h2 className='courses__name'>{course.name}</h2>
                            <div className='courses__recommendations'>
                                {course.criticalCount > 0 &&
                                    <div className='courses__recommendation'>
                                        <FaExclamation className='courses__criticalIcon' />
                                        {course.criticalCount} critical
                                    </div>
                                }
                                {course.recommendedCount > 0 &&
                                    <div className='courses__recommendation'>
                                        <RiMoreFill className='courses__recommendedIcon' />
                                        {course.recommendedCount} advised to review
                                    </div>
                                }
                            </div>
                            <div className='courses__progressBar'>
                                <span style={{ width:
                                    `${course.progress*100}%`
                                }}></span>
                            </div>
                            <p className='courses__progress'>{(course.progress*100).toFixed(1)}% watched</p>
                        </div>
                        <MdPlayCircle className='courses__statusIcon' />
                    </button>
                ))}
            </div>
        </div>
    );
}

export default Courses;